export default [
  {
    path: 'afiliados/cadastros-afiliados',
    name: 'cadastros-afiliados',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Clientes',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Afiliados', link: 'afiliados' },
        { name: 'Clientes' },
      ]
    }
  },
]